import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Notification, NotificationType } from 'edenred-ui';

import { TopSection } from '../../BeneficiariesListStyles';

export const BeneficiariesTopSection = () => {
  const { t } = useTranslation();
  const [showContent, setShowContent] = useState(true);
  return (
    <TopSection>
      <div className="employee-added-notification">
        {showContent && (
          <Notification
            type={NotificationType.Success}
            text={
              <Box display="ruby">
                {t('employees.employee_added_notification')}
              </Box>
            }
            onClose={() => setShowContent(false)}
          />
        )}
      </div>
    </TopSection>
  );
};
